export { default as ConfirmEntityView, type ConfirmEntityViewProps } from './ConfirmEntityView';
